import type { GetShowQuery } from "@/codegen/graphql/generated/graphql";

/**
 * The one access rule of the player: an episode is locked when it isn't free
 * and the user isn't premium.
 *
 * It answers four questions that have to move together — whether the stream is
 * loaded and autoplayed, whether the episode list shows a lock, whether the
 * paywall opens, and (because the paywall slides the user straight back)
 * whether leaving the previous episode counts as watching it. Written inline,
 * a change to the rule reaches some of them and silently skips the others.
 *
 * Not for `findIndex(e => !e.free)`: that one asks where the paid episodes
 * start in the catalog, which doesn't depend on the user.
 */
const isEpisodeLocked = (
  episode: Pick<GetShowQuery["show"]["episodes"][number], "free">,
  isPremiumUser: boolean,
) => !episode.free && !isPremiumUser;

export default isEpisodeLocked;
